// 通知マスタの一覧表のラベル
export const LABELS = {
  NOTICE_ID: "ID",
  NOTICE_CONDITION: "条件名",
  NOTICE_USAGE: "条件利用用途",
  NOTICE_FROM: "From",
  NOTICE_FROM_NAME: "From（表示名）",
  NOTICE_FROM_ADDRESS: "From（アドレス）",
  NOTICE_TO: "To",
  NOTICE_CC: "Cc",
  NOTICE_BCC: "Bcc",
  NOTICE_SUBJECT: "件名",
  NOTICE_MAIL: "メール本文",
  NOTICE_LAST_UPDATED_DATE: "最終更新日",
  NOTICE_LAST_UPDATED_BY: "最終更新者",
  NOTICE_PARAMETER: "使用可能パラメータ一覧",
  TABLE_TITLE: "通知マスタ",
} as const;
